import React from "react";
import { Flex } from "@chakra-ui/react";
import { CreateMedication, MedicationGroup } from "components";
import { useCurrentCase } from "duck";
import { MedicationCalculationTypeEnum } from "requests";
import {
  useCreateMedication,
  useDeleteMedication,
  useUpdateMedication
} from "../../../shared/medications/duck";
import { Miscellaneous } from "./components";
import * as duck from "./duck";

const Medication: React.FC = () => {
  const medicationCalculations = useCurrentCase(
    ({ data }) => data.client.patient.medicationCalculations
  );

  const deleteMedication = useDeleteMedication();
  const create = useCreateMedication();
  const updateCalculation = useUpdateMedication();

  return (
    <Flex direction="column" rowGap={12}>
      <MedicationGroup.Provider update={updateCalculation}>
        <MedicationGroup
          groupName="Pre-Anesthetic Medications"
          medications={medicationCalculations?.filter(
            calc =>
              calc?.calculationType ===
              MedicationCalculationTypeEnum.PreAnesthetic
          )}
          create={
            <CreateMedication
              calculationType={MedicationCalculationTypeEnum.PreAnesthetic}
              defaultConcentrations={duck.PRE_ANESTHETIC_CONCENTRATIONS}
              successToast="Pre-Anesthetic Medication is created successfully."
              onSubmit={values =>
                create(values, MedicationCalculationTypeEnum.PreAnesthetic)
              }
            />
          }
          onDelete={deleteMedication}
          medicationType={MedicationCalculationTypeEnum.PreAnesthetic}
        />

        <MedicationGroup
          groupName="Induction Medications"
          medications={medicationCalculations?.filter(
            calc =>
              calc?.calculationType === MedicationCalculationTypeEnum.Induction
          )}
          create={
            <CreateMedication
              calculationType={MedicationCalculationTypeEnum.Induction}
              defaultConcentrations={duck.INDUCTION_CONCENTRATIONS}
              successToast="Induction Medication is created successfully."
              onSubmit={values =>
                create(values, MedicationCalculationTypeEnum.Induction)
              }
            />
          }
          onDelete={deleteMedication}
          medicationType={MedicationCalculationTypeEnum.Induction}
        />

        <MedicationGroup
          groupName="Additional Medications"
          medications={medicationCalculations?.filter(
            calc =>
              calc?.calculationType === MedicationCalculationTypeEnum.Additional
          )}
          create={
            <CreateMedication
              calculationType={MedicationCalculationTypeEnum.Additional}
              defaultConcentrations={duck.ADDITIONAL_CONCENTRATIONS}
              successToast="Additional Medication is created successfully."
              onSubmit={values =>
                create(values, MedicationCalculationTypeEnum.Additional)
              }
            />
          }
          onDelete={deleteMedication}
          medicationType={MedicationCalculationTypeEnum.Additional}
        />
      </MedicationGroup.Provider>

      <Miscellaneous />
    </Flex>
  );
};

export default Medication;
